module.exports = __webpack_public_path__ + "static/3ba25035.500.png";